import * as React from "react";
import * as styles from "./styles.scss";
import { Html } from "../../../../components";

interface IProps {
  question: {
    options: {
      options: {
        image: number,
        text: string,
      }[],
    },
  },
  value: {
    image: {
      id: number,
    },
    text: string,
    isRight?: boolean,
  }[],
}

const renderRelationTextImage = (props: any, i: any) => {
  return (
    <div className={styles.relation} key={i}>
      <div className={`${styles.left} ${!props.isRight ? styles.wrong : ""}`}>
        <img src={props.image.src} />
      </div>
      <div className={styles.middle}>
        <svg x="0px" y="0px" viewBox="0 0 61.49 31.49">
          <g>
            <path
              style={{ fill: "#1E201D", transform: "translateX(29px)" }}
              d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"
            />
            <path
              style={{ fill: "#1E201D" }}
              d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
            />
          </g>
        </svg>
      </div>
      <div className={styles.right}>
        <Html>{props.text}</Html>
      </div>
    </div>
  );
};

export const RelationTextImage = (props: IProps) => {
  const [data, setData] = React.useState<IProps>(props);

  React.useEffect(() => {
    const relationTextImageData = { ...props };

    const rightAnswers: { [key: number]: string } = relationTextImageData.question.options.options.reduce(
      (obj, item) => Object.assign(obj, { [item.image]: item.text }), {}
    );

    relationTextImageData.value = relationTextImageData.value.map((item) => {
      const isRight = item.image.id in rightAnswers && rightAnswers[item.image.id] === item.text;

      return {
        ...item,
        isRight: isRight
      }
    });

    setData(relationTextImageData);
  }, []);

  return (
    <div className={styles.relations}>
      {data.value.map(renderRelationTextImage)}
    </div>
  )
}
